/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-row :gutter="16">
    <a-col :span="5">
      <a-card :body-style="{padding: '16px 10px'}" :bordered="false" class="cabinet">
        <station-select @select="stationSelect" />
      </a-card>
    </a-col>
    <a-col :span="19">
      <a-card :body-style="{padding: '24px'}" :bordered="false" class="cabinet">
        <a-list size="large">
          <a-list-item
              class="cabinet-item"
              :class="{
                  processing: item.status === '1',
                  error: item.status === '9',
                  warning: item.status === '2',
                }"
              :key="index" v-for="(item, index) in list">
            <a-list-item-meta>
              <a-avatar slot="avatar" size="large" shape="square">
                {{ item.serial }}
              </a-avatar>
              <a slot="title">{{ item.stationId.name }}</a>
              <span slot="description">
              <!-- 通道组: {{ item.cabnum }}-{{ item.channel }} -->
              {{ item.lastOpenTime ? item.lastOpenTime : '无' }}
              </span>
            </a-list-item-meta>
            <div slot="actions">
              <a-button type="link" @click="checkBox(item)" style="padding:0;">检查</a-button>
              <a-divider type="vertical" />
              <a-popconfirm
                  title="你确定要开箱么?"
                  ok-text="确定"
                  cancel-text="放弃"
                  @confirm="openCabinet(item._id)">
                <a href="#">开箱</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a-popconfirm
                  title="你确定要恢复这个格子么?请先检查一下是否还有快递"
                  ok-text="确定"
                  cancel-text="放弃"
                  @confirm="recoverCabinet(item)">
                <a href="#">恢复</a>
              </a-popconfirm>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <span>规格：{{ item.type }}</span>
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <cabinet-status :status="item.status" />
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
              通道组:{{ item.cabnum }}-{{ item.channel }}
                <!-- <span>最后开箱时间: {{ item.lastOpenTime ? item.lastOpenTime : '无' }}</span> -->
                <!-- <span>锁状态：</span>
                <a-icon type="lock" v-if="item.lockStatu === 0" style="color: red" />
                <a-icon type="unlock" v-else style="color: green" /> -->
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <span>快递：</span>
                <a-tag color="#87d068" v-if="item.canuse">无</a-tag>
                <a-tag color="#108ee9" v-else>有</a-tag>
              </div>
            </div>
            <div class="list-content">
              <div class="list-content-item">
                <span>备注: {{ item.desc ? item.desc : '无' }}</span>
              </div>
              <!-- <div class="list-content-item">
                <span>最后开箱时间: {{ item.lastOpenTime ? item.lastOpenTime : '无' }}</span>
              </div> -->
            </div>
          </a-list-item>
        </a-list>
        <div style="text-align: center">
          <a-pagination :default-current="1" :total="pager.total" :showTotal="pager.showTotal" :pageSize="pager.pageSize" @change="pagerChange"/>
        </div>
      </a-card>
    </a-col>
    <cabinet-add ref="cabinetAdd" @cancel="getList" />
    <add-and-modify ref="addAndModify" :stationId="searchForm.stationId" @close="getList" />
  </a-row>
</template>

<script type="text/babel">
import { mapActions, mapState, mapGetters } from 'vuex';
import { stationCabnums } from '@/api/station';
import {
  createCabinet,
  emptyBbox,
  openbox,
  modify,
} from '@/api/cabinet';
import { packagesList } from '@/api/bussiness';

import CabinetAdd from './add.vue';
import addAndModify from './addAndModify.vue';

export default {
  components: { CabinetAdd, addAndModify },
  data() {
    return {
      listloading: false,
      searchForm: {
        stationId: '',
        status: '',
        cabnum: '',
        pageSize: 10,
        page: 1,
      },
      visible: true,
      cabnums: [],
      list: [],
      pager: {
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapState({

    }),
    ...mapGetters(['cabinetStatus']),
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions(['getStationList']),
    showMultiAdd() {
      this.$refs.cabinetAdd.show(this.searchForm.stationId);
    },
    showAdd() {
      this.$refs.addAndModify.show();
    },
    showModify(item) {
      this.$refs.addAndModify.show(item);
    },
    async openCabinet(id) {
      const { data: { success, msg } } = await openbox(id);
      if (success) {
        this.$message.success(msg);
      } else {
        this.$message.error(msg);
      }
    },
    handleButtonClick() {},
    handleMenuClick() {},
    stationSelect(stationId) {
      this.searchForm.stationId = stationId;
      this.getStationCabnums();
      this.getList();
    },
    async getStationCabnums() {
      const { data } = await stationCabnums(this.searchForm.stationId);
      this.cabnums = data;
    },
    async create() {
      const { data } = createCabinet();
      if (data) {
        this.$message.success('添加成功');
      }
    },
    // go(param) {
    //   const { name, query } = this.$route;
    //   this.$router.push({name, query: {...param, ...query}});
    // },
    async getList() {
      this.listloading = true;
      const { data: { docs, pager } } = await emptyBbox(this.searchForm);
      this.list = docs;
      this.pager = {
        ...pager,
        showTotal: (total) => `共计 ${total} 条信息`,
      };
      this.listloading = false;
    },
    pagerChange(page) {
      this.searchForm.page = page;
      this.getList();
    },
    async recoverCabinet(item) {
      // eslint-disable-next-line no-underscore-dangle
      await modify(item._id, { status: 1, canuse: true });
      this.$message.success('操作成功');
      this.getList();
    },
    async checkBox(item) {
      const station = item.stationId.id;
      const { serial } = item;
      const { data: { pager } } = await packagesList({
        station,
        status: 0,
        'cabinet.serial': serial,
      });
      if (pager.total === 0) {
        return this.$notification.success({
          message: '业务数据为空可以恢复',
          description: '此格子对应的业务数据为空可以安全释放',
        });
      }
      const url = `/business/packageslist?station=${item.stationId.id}&status=0&cabinet.serial=${serial}`;
      return window.open(url, '派件数据查询', 'location=no,channelmode=yes,width=1280,height=800');
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.cabinet {
  .ant-avatar{
    font-size: 20px;
  }
  &-item{
    .ant-avatar{
      background: rgba(0,0,0,.09);
    }
    &.processing{
        .ant-avatar{
          background: rgb(135, 208, 104);
        }
    }
    .warning{
      .ant-avatar{
        background: #faad14;
      }
    }
    &.error{
      .ant-avatar{
        background: #f5222d;
      }
    }
  }
}
.list-content-item {
  color: rgba(0, 0, 0, .45);
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 40px;
  span {
    line-height: 20px;
  }
  p {
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 22px;
  }
}
</style>
